/**
 * Returns the Phaser hex color for a Material item's outline based on its price.
 * Returns null if the item is not Material type.
 */
export function getMaterialOutlineColor(price: number): number {
  if (price < 11) return 0x888888; // gray
  if (price < 100) return 0x4488ff; // blue
  return 0xffd700; // yellow
}

// Blueprint styling for Recipe-type items: a deep-navy fill with lighter grid lines,
// drawn behind the item sprite so recipes read as "blueprints" wherever they're shown.
export const BLUEPRINT_BG = 0x0f2e52;
export const BLUEPRINT_LINE = 0x6fa8dc;

export const COLORS = {
  GREEN: "#22dd88", // Used for open/close buttons
  GRAY: "#888888", // Used for inventory slot backgrounds
  WHITE: "#ffffff", // Used for slot borders
  RED: "#E92D18", // Used for health bar
  ORANGE: "#ffaa00",
  BLUE: "#3399ff", // Used for squad slots
  YELLOW: "#ffe066", // Used for credits display
  BLACK: "#222222", // Used for credits text stroke
  FG: "#36629a", // Foreground color for windows
  BG: "#4c9ac6", // Background color for windows
};

/**
 * Converts a hex color string to a numeric value for Phaser
 * @param hexColor - Hex color string (e.g., "#27ae60")
 * @returns Numeric color value for Phaser (e.g., 0x27ae60)
 */
export function hexToPhaser(hexColor: string): number {
  return parseInt(hexColor.replace("#", ""), 16);
}

/**
 * Helper method to darken a color by a percentage
 * @param color - The color as a number (e.g., 0x36629a)
 * @param amount - Amount to darken (0 to 1, where 0.3 = 30% darker)
 * @returns The darkened color as a number
 */
export function darkenColor(color: number, amount: number): number {
  const r = (color >> 16) & 0xff;
  const g = (color >> 8) & 0xff;
  const b = color & 0xff;

  const newR = Math.floor(r * (1 - amount));
  const newG = Math.floor(g * (1 - amount));
  const newB = Math.floor(b * (1 - amount));

  return (newR << 16) | (newG << 8) | newB;
}
